<link rel="ractive" href="../r-page.html">
<link rel="ractive" href="../components/header.html" name="c-header">
<link rel="ractive" href="../components/footer.html" name="c-footer">
<link rel="ractive" href="../components/notification.html" name="c-notification">
<link rel="ractive" href="../components/header-gradient.html" name="c-header-gradient">

<r-page noYield="{{noYield}}" title="{{title}}" description="{{description}}">
	<c-notification></c-notification>
	<c-header useWhiteLogos="true" additionalClasses="header-with-orange-bg"></c-header>

	<div class="p-history">
		<c-header-gradient showMap="{{true}}"></c-header-gradient>
		<div class="navigation">
			<a href="/about">About Us</a>
			<a href="/history" class="active">Our History</a>
		</div>

		<div class="p-history_container">
			<div class="p-history_container_title">
				<span>jsDelivr over the years </span>
				<span>Our History</span>
			</div>

			<div class="p-history_container_content">
				{{#each eventsData}}
					<section>
						<div class="year">{{year}}</div>

						{{#each events}}
							<div class="event-block">
								<div class="event-block_month">
									<div class="binding"></div>
									<div class="month">{{month}}</div>
									<div class="binding"></div>
								</div>

								<div class="event-block_main {{index % 2 ? 'pos-right' : 'pos-left'}}">
									{{#if data.type}}
										<img class="event-block_main_type-icon" src="{{@shared.assetsHost}}/img/history/{{data.type}}.svg">
									{{/if}}

									{{#if data.text}}
										<div class="event-block_main_content">
											<span>{{{data.text}}}</span>

											{{#if data.img && data.img.ext === ".svg"}}
												<img class="{{data.img.class}}"
													width="{{data.img.widthSmall}}"
													src="{{@shared.assetsHost}}/img/history/{{data.img.name}}{{data.img.ext}}">
											{{elseif data.img && data.img.ext === ".png"}}
												<img class="{{data.img.class}}"
													width="{{data.img.widthSmall}}"
													src="{{@shared.assetsHost}}/img/history/{{data.img.name}}{{data.img.ext}}"
													srcset="{{@shared.assetsHost}}/img/history/{{data.img.name}}@2x{{data.img.ext}} 2x">
											{{/if}}
										</div>
									{{/if}}
								</div>

								<div class="event-block_relation {{index % 2 ? 'pos-left' : 'pos-right'}}">
									{{#if data.img && data.img.ext === ".svg"}}
										<img class="{{data.img.class}}"
											width="{{data.img.widthLarge}}"
											src="{{@shared.assetsHost}}/img/history/{{data.img.name}}{{data.img.ext}}">
									{{elseif data.img && data.img.ext === ".png"}}
										<img class="{{data.img.class}}"
											width="{{data.img.widthLarge}}"
											src="{{@shared.assetsHost}}/img/history/{{data.img.name}}{{data.img.ext}}"
											srcset="{{@shared.assetsHost}}/img/history/{{data.img.name}}@2x{{data.img.ext}} 2x">
									{{/if}}
								</div>
							</div>
						{{/each}}
					</section>
				{{/each}}
			</div>
		</div>
	</div>

	<c-footer></c-footer>
</r-page>

<script>
	const DATA_TYPE_UPDATES = 'updates';
	const DATA_TYPE_DEALS = 'deals';
	const DATA_TYPE_NUMBERS = 'numbers';

	component.exports = {
		data () {
			return {
				title: 'Our History - jsDelivr',
				description: 'History and milestones',
				eventsData: [
					{
						year: '2024',
						events: [
							{
								month: 'September',
								data: {
									text: '<a target="_blank" rel="noopener noreferrer" href="https://dash.globalping.io/">Globalping Dashboard</a> goes live with extra benefits for registered users and sponsors',
									type: DATA_TYPE_UPDATES,
								},
							},
							{
								month: 'March',
								data: {
									text: 'Served 260 billion monthly requests, exceeding a 8.5B / day average',
									type: DATA_TYPE_NUMBERS,
								},
							},
						],
					},
					{
						year: '2023',
						events: [
							{
								month: 'May',
								data: {
									text: '<a href="https://globalping.io/">Globalping</a> goes live! Includes CLI and Slack App',
									type: DATA_TYPE_UPDATES,
								},
							},
							{
								month: 'April',
								data: {
									text: 'jsDelivr joined the <a target="_blank" rel="noopener noreferrer" href="https://cdnalliance.org/">CDN Alliance</a> as an official member',
									type: DATA_TYPE_DEALS,
									img: {
										name: 'cdn-alliance-logo',
										widthLarge: '234',
										widthSmall: '32',
										ext: '.svg',
									},
								},
							},
							{
								month: 'February',
								data: {
									text: 'Served 200 billion monthly requests for the first time',
									type: DATA_TYPE_NUMBERS,
								},
							},
							{
								month: 'January',
								data: {
									text: 'Website redesigned to support new ESM features and provide more information about packages',
									type: DATA_TYPE_UPDATES,
								},
							},
						],
					},
					{
						year: '2022',
						events: [
							{
								month: 'December',
								data: {
									text: 'New DNS system and simplified Multi-CDN routing for better performance and availability',
									type: DATA_TYPE_UPDATES,
								},
							},
							{
								month: 'December',
								data: {
									text: 'Served 180B requests, reaching a 6B / day average',
									type: DATA_TYPE_NUMBERS,
								},
							},
							{
								month: 'August',
								data: {
									text: 'Gcore joins as a sponsor',
									type: DATA_TYPE_DEALS,
									img: {
										name: 'g-core',
										widthLarge: '148',
										widthSmall: '74',
										ext: '.svg',
									},
								},
							},
							{
								month: 'July',
								data: {
									text: '<a href="https://github.com/jsdelivr/globalping" >Globalping</a> launches in Beta',
									type: DATA_TYPE_UPDATES,
									img: {
										name: 'globalping',
										widthLarge: '208',
										widthSmall: '104',
										ext: '.svg',
									},
								},
							},
						],
					},
					{
						year: '2021',
						events: [
							{
								month: 'October',
								data: {
									text: 'On-the-fly SVG optimization goes live',
									type: DATA_TYPE_UPDATES,
								},
							},
							{
								month: 'September',
								data: {
									text: 'Served 130B requests, 6 PB of bandwidth per month',
									type: DATA_TYPE_NUMBERS,
								},
							},
							{
								month: 'May',
								data: {
									text: 'RawGit CDN becomes part of jsDelivr',
									type: DATA_TYPE_DEALS,
									img: {
										name: 'rawgit',
										widthLarge: '68',
										widthSmall: '52',
										ext: '.png',
									},
								},
							},
							{
								month: 'February',
								data: {
									text: 'BunnyCDN joins as a sponsor',
									type: DATA_TYPE_DEALS,
									img: {
										name: 'bunny',
										widthLarge: '148',
										widthSmall: '104',
										ext: '.svg',
									},
								},
							},
						],
					},
					{
						year: '2020',
						events: [
							{
								month: 'October',
								data: {
									text: '<a href="/esm">esm.run</a> launches to make jsDelivr a first choice CDN for ES modules',
									type: DATA_TYPE_UPDATES,
								},
							},
							{
								month: 'October',
								data: {
									text: '<a href="/blog/jsdelivr-welcomes-bootstrapcdn/" class="router-ignore">BootstrapCDN</a> becomes part of jsDelivr',
									type: DATA_TYPE_DEALS,
									img: {
										name: 'bootstrap',
										widthLarge: '147',
										widthSmall: '104',
										ext: '.png',
									},
								},
							},
							{
								month: 'October',
								data: {
									text: '<a href="/oss-cdn/pyodide">Pyodide</a> becomes powered by jsDelivr, speeding up WASM delivery',
									type: DATA_TYPE_DEALS,
									img: {
										name: 'pyodide',
										widthLarge: '105',
										widthSmall: '63',
										ext: '.png',
									},
								},
							},
							{
								month: 'May',
								data: {
									text: '<a href="/oss-cdn/cocoa">CocoaPods</a> becomes powered by jsDelivr, speeding up the installation of packages',
									type: DATA_TYPE_DEALS,
									img: {
										name: 'cocoapods',
										widthLarge: '147',
										widthSmall: '104',
										ext: '.png',
									},
								},
							},
						],
					},
					{
						year: '2019',
						events: [
							{
								month: 'October',
								data: {
									text: 'Served 60B requests, reaching a 2B / day average',
									type: DATA_TYPE_NUMBERS,
								},
							},
							{
								month: 'May',
								data: {
									text: 'The jsDelivr team builds PerfOps, a commercial service to improve multi-CDN routing',
									type: DATA_TYPE_DEALS,
									img: {
										name: 'perfops',
										widthLarge: '147',
										widthSmall: '104',
										ext: '.svg',
									},
								},
							},
						],
					},
					{
						year: '2018',
						events: [
							{
								month: 'October',
								data: {
									text: 'Plugins for Atom, IntelliJ, and Visual Studio released',
									type: DATA_TYPE_UPDATES,
								},
							},
							{
								month: 'September',
								data: {
									text: 'Served 30 billion requests per month, reaching a daily average of 1B for the first time',
									type: DATA_TYPE_NUMBERS,
								},
							},
						],
					},
					{
						year: '2017',
						events: [
							{
								month: 'August',
								data: {
									text: 'Website rebuilt to support the new automated system that works with NPM and GitHub directly.',
									type: DATA_TYPE_UPDATES,
								},
							},
							{
								month: 'July',
								data: {
									text: 'Data API launches, providing detailed download statistics',
									type: DATA_TYPE_UPDATES,
								},
							},
							{
								month: 'May',
								data: {
									text: 'Fully automated npm and GitHub proxies launch',
									type: DATA_TYPE_UPDATES,
								},
							},
							{
								month: 'April',
								data: {
									text: 'Fastly joins as a sponsor',
									type: DATA_TYPE_DEALS,
									img: {
										name: 'fastly',
										widthLarge: '84',
										widthSmall: '50',
										ext: '.svg',
									},
								},
							},
						],
					},
					{
						year: '2016',
						events: [
							{
								month: 'April',
								data: {
									text: 'OSSCDN becomes part of jsDelivr',
									type: DATA_TYPE_UPDATES,
								},
							},
							{
								month: 'February',
								data: {
									text: 'Martin Kolárik joins as core developer',
									type: DATA_TYPE_DEALS,
									img: {
										name: 'martin-kolarik',
										widthLarge: '80',
										widthSmall: '56',
										ext: '.png',
										class: 'img-rounded',
									},
								},
							},
						],
					},
					{
						year: '2015',
						events: [
							{
								month: 'November',
								data: {
									text: 'Served 7 billion requests, 132 TB per month',
									type: DATA_TYPE_NUMBERS,
								},
							},
							{
								month: 'September',
								data: {
									text: 'Quantil joins as a sponsor, adds locations in mainland China',
									type: DATA_TYPE_DEALS,
									img: {
										name: 'quantil',
										widthLarge: '105',
										widthSmall: '53',
										ext: '.png',
									},
								},
							},
							{
								month: 'September',
								data: {
									text: 'Complete redesign of the website',
									type: DATA_TYPE_UPDATES,
								},
							},
						],
					},
					{
						year: '2014',
						events: [
							{
								month: 'December',
								data: {
									text: 'NS1 joins as a sponsor',
									type: DATA_TYPE_DEALS,
									img: {
										name: 'ns1',
										widthLarge: '68',
										widthSmall: '52',
										ext: '.svg',
									},
								},
							},
							{
								month: 'December',
								data: {
									text: 'WordPress plugins proxy launches',
									type: DATA_TYPE_UPDATES,
								},
							},
							{
								month: 'November',
								data: {
									text: 'Purge API launches',
									type: DATA_TYPE_UPDATES,
								},
							},
							{
								month: 'July',
								data: {
									text: 'Serving multiple files in one response possible thanks to /g/',
									type: DATA_TYPE_UPDATES,
								},
							},
							{
								month: 'June',
								data: {
									text: 'Automated project updates via libgrabber',
									type: DATA_TYPE_UPDATES,
								},
							},
							{
								month: 'April',
								data: {
									text: 'jsDelivr becomes the fastest open-source CDN according to CDNPerf',
									type: DATA_TYPE_UPDATES,
								},
							},
							{
								month: 'March',
								data: {
									text: 'Cloudflare joins as a sponsor',
									type: DATA_TYPE_DEALS,
									img: {
										name: 'cloudflare',
										widthLarge: '118',
										widthSmall: '90',
										ext: '.svg',
									},
								},
							},
						],
					},
					{
						year: '2013',
						events: [
							{
								month: 'December',
								data: {
									text: 'Public data API launches',
									type: DATA_TYPE_UPDATES,
								},
							},
							{
								month: 'June',
								data: {
									text: 'Cedexis joins as a sponsor, allows multi-CDN routing based on RUM',
									type: DATA_TYPE_DEALS,
									img: {
										name: 'cedexis',
										widthLarge: '119',
										widthSmall: '76',
										ext: '.png',
									},
								},
							},
							{
								month: 'May',
								data: {
									text: 'CDN.NET joins as a sponsor',
									type: DATA_TYPE_DEALS,
									img: {
										name: 'cdnnet',
										widthLarge: '118',
										widthSmall: '90',
										ext: '.png',
									},
								},
							},
						],
					},
					{
						year: '2012',
						events: [
							{
								month: 'June',
								data: {
									text: 'MaxCDN joins as a sponsor',
									type: DATA_TYPE_DEALS,
									img: {
										name: 'maxcdn',
										widthLarge: '132',
										widthSmall: '106',
										ext: '.svg',
									},
								},
							},
							{
								month: 'May',
								data: {
									text: 'Dmitriy Akulov founds jsDelivr',
									type: DATA_TYPE_DEALS,
									img: {
										name: 'dmitriy-akulov',
										widthLarge: '80',
										widthSmall: '56',
										ext: '.png',
										class: 'img-rounded',
									},
								},
							},
						],
					},
				].map((yearData, index, years) => {
					let before = years.slice(0, index).reduce((acc, val) => acc + val.events.length, 0);

					return {
						...yearData,
						events: yearData.events.map((event, index) => {
							return {
								...event,
								index: index + before,
							};
						}),
					};
				}),
			};
		},
	};
</script>
